// 正则判断


/**
 * 验证是否为手机号
 * @param phone 手机号 [string | number]
 */
export const isPhone = function (phone) {
    return /^1[3456789]\d{9}$/.test(phone + '');
};

/**
 * 验证是否为电话号
 * @param tel 电话号 [string | number]
 */
export const isTel = function (tel) {
    return /^(\d{3,4}-)?\d{7,8}$/.test(tel + '');
};

/**
 * 验证是否为邮箱
 * @param email 邮箱 [string]
 */
export const isEmail = function (email) {
    return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(email + '');
};

/**
 * 是否为域名
 * @param url 域名 [string]
 */
export const isDomain = function (domain) {
    return /^([\w-]+\.)+[\w-]+$/.test(domain + '');
};

/**
 * 是否为网址
 * @param url 网址 [string]
 */
export const isUrl = function (url) {
    return /^([\w-]+\.)+[\w-]+(:\d+)?(\/?[\w-./?%&=#]*)?$/.test(url + '');
};

/**
 * 是否为带 http 或 https 或 // 的网址
 * @param url 地址 [string]
 */
export const isHttp = function (url) {
    return /^(https?:)?\/\/([\w-]+\.)+[\w-]+(:\d{1,5})?(\/?[\w-./?%&=#]*)?$/.test(url + '');
};

/**
 * 是否为qq号
 * @param qq qq号 [string | number]
 */
export const isQQ = function (qq) {
    return /[1-9][0-9]{4,}/.test(qq + '');
};

/**
 * 是否为微信号
 * @param wx 微信号 [string | number]
 */
export const isWX = function (wx) {
    return /^[a-zA-Z]([-_a-zA-Z0-9]{5,19})+$/.test(wx + '');
};

/**
 * 是否为银行卡号
 * @param code 卡号 [string | number]
 */
export const isBankCode = function (code) {
    return /^([1-9]{1})(\d{14}|\d{18})$/.test(code + '');
};

/**
 * 是否为身份证号
 * @param code 身份证号 [string | number]
 */
export const isIdCode = function (code) {
    return /^[1-9]\d{11,17}[\dxX]$/.test(code + '');
};

/**
 * 是否为中国邮政编码
 * @param code 邮政编码 [string | number]
 */
export const isPostCode = function (code) {
    return /^[1-9]\d{5}(?!\d)$/.test(code + '');
};
